export default "__VITE_ASSET__Bd73wFiq__"